import _store from "../../../index";

const fields = [
  "utm_source",
  "utm_placement",
  "utm_creative",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_campaign",
  "gclid",
  "ga.clientId",
  "ga.trackingId",
  "ga.referrer",
  "ga.location",
  "ga._gclid"
];
const defaultState = () => ({
  data: undefined,
  received: undefined,
  script_params: {
    utm_feedback_btn: {
      lead: fields,
      contact: fields
    }
  }
});

const state = defaultState();

// getters
const getters = {
  allowedScripts: state => {
    if (state.received === undefined) {
      _store.dispatch("cache/allowed_scripts/getAllowedScripts");
      return undefined;
    }
    return state.data;
  }
};

// actions
const actions = {
  getAllowedScripts(store) {
    if (state.received !== undefined) {
      return;
    }
    store.commit("setReceived", false);
    store.rootState.api
      .query({
        query: require("../../../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\Http\\Controllers\\Api\\spa\\StaticController",
          method: "getScriptsList",
          params: {}
        }
      })
      .then(res => {
        let data = res.data.opupet_query;
        store.commit(
          "setData",
          Object.keys(data).reduce((r, v) => {
            r[v] = Object.assign({ code: v }, data[v]);
            return r;
          }, {})
        );
        store.commit("setReceived", true);
      })
      .catch(() => {
        store.commit("setReceived", undefined);
      });
    return state;
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = data;
  },
  setReceived(state, value) {
    state.received = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
